import { useEffect, useState } from "react";
import { Tile } from "../../reactOL/layers";
import { OSMGreyscale, OSMGreyscaleDark } from "../../reactOL/source";
import { useThemeContext } from "../../theme/ThemeContext";
import { Theme } from "../../../constant/Theme";
import olOSMSource from "ol/source/OSM";

const OsmTileLayer = () => {
  const [osm, setOsm] = useState(OSMGreyscale());
  const { theme } = useThemeContext();

  useEffect(() => {
    if (theme === Theme.DARK) {
      setOsm(OSMGreyscaleDark());
    } else {
      setOsm(new olOSMSource());
    }
  }, [theme]);
  return <Tile source={osm}></Tile>;
};

export default OsmTileLayer;
